import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import { getCdnUrl } from '../../../helpers';
import factoringVideoData from '../../../constants/products/factoring-video';
import {
  STACK_CENTER_ROW_DIRECTION,
  STACK_CENTER,
  STACK_START_COLUMN_DIRECTION,
} from '../../../constants/mui-components';
import {
  videoSectionContainer,
  titleTypography,
  descriptionTypography,
  videoContentStack,
  videoImageContainer,
  videoImageStyles,
} from '../styles/factoring-video-section.styles';

function FactoringVideoSection() {
  const theme = useTheme();
  return (
    <Stack
      className={STACK_CENTER_ROW_DIRECTION}
      sx={videoSectionContainer}
    >
      <Stack
        className={STACK_CENTER}
        sx={videoContentStack(theme)}
      >
        <Stack
          className={STACK_START_COLUMN_DIRECTION}
          gap="1.5rem"
        >
          <Typography
            variant="xlarge_3"
            sx={titleTypography}
          >
            {factoringVideoData.title}
          </Typography>
          <Typography variant="medium_2" sx={descriptionTypography}>
            {factoringVideoData.description}
          </Typography>
        </Stack>
        <Box
          onClick={() => { window.open(factoringVideoData.video, '_blank'); }}
          sx={videoImageContainer}
        >
          <CardMedia
            component="img"
            image={getCdnUrl(factoringVideoData.image)}
            alt="tutorial_video"
            style={videoImageStyles}
          />
        </Box>
      </Stack>
    </Stack>
  );
}

export default FactoringVideoSection;
